import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import PaymentEntry from "../../components/PaymentEntry/PaymentEntry";

const PaymentEntryPage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Payment Entry">
        <PaymentEntry />
      </Layout>
    </div>
  );
};

export default PaymentEntryPage;

